import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import './news.css';
import Typingadd from './typingadd';
import Convertersadd from './convertersadd';
import Posts from './posts';
import Recent from './recent';
import Trending from './trending';
import load from './ZKZg.gif';
export default function News() {



  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://aiharsoreersu.net/act/files/tag.min.js?z=8718127";
    script.setAttribute("data-cfasync", "false");
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Clean up the script to avoid duplicate injections
      document.body.removeChild(script);
    };
  }, []);


  const [post, setPost] = useState(null);
  const { id, collection } = useParams();
  const containerRef = useRef(null);
  const [likeCount, setLikeCount] = useState(0);
  const [likeColor, setLikeColor] = useState('grey');

  useEffect(() => {
    if (post) {
      document.title = `${post.title}`;
    } else {
      document.title = 'Loading... | Your Source for Latest News';
    }
  }, [post, collection]);

  useEffect(() => {
    const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/api/${collection}/${id}?incrementView=true`;
  
    fetch(apiUrl)
      .then((response) => response.json())
      .then((data) => {
        setPost(data);
        setLikeCount(data.like || 0); 
      })
  }, [collection, id]);
   const convertBinaryToBase64 = (binaryData) => {
    return `data:image/jpeg;base64,${binaryData}`;
  };

  const updateImageSrc = useCallback((htmlContent, images) => {
    if (!htmlContent) return htmlContent;

    let updatedContent = htmlContent;
    const imgTagRegex = /<img\s+([^>]*?src="[^"]*")[^>]*>/g;
    let match;
    let imgIndex = 0;

    while ((match = imgTagRegex.exec(updatedContent)) !== null) {
      if (images[imgIndex]) {
        const currentSrc = match[1];
        const newSrc = `src="${convertBinaryToBase64(images[imgIndex])}"`;
        updatedContent = updatedContent.replace(currentSrc, newSrc);
      }
      imgIndex++;
    }

    return updatedContent;
  }, []);

  const applyStylesToPost = (htmlContent) => {
    const styleTags = htmlContent.match(/<style[^>]*>[\s\S]*?<\/style>/gi);
    let styles = '';

    if (styleTags) {
      styleTags.forEach((tag) => {
        styles += tag.replace(/<style[^>]*>/, '').replace(/<\/style>/, '') + '\n';
      });
    }

    const contentWithoutStyles = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');

    return { styles, contentWithoutStyles };
  };

  const applyShadowDOM = (styles, htmlContent) => {
    const containerElement = containerRef.current;

    if (containerElement) {
      let shadowRoot = containerElement.shadowRoot;
      if (!shadowRoot) {
        shadowRoot = containerElement.attachShadow({ mode: 'open' });
      }

      shadowRoot.innerHTML = '';

      const styleElement = document.createElement('style');
      styleElement.textContent = styles;
      shadowRoot.appendChild(styleElement);

      const contentDiv = document.createElement('div');
      contentDiv.innerHTML = htmlContent;
      shadowRoot.appendChild(contentDiv);
    }
  };

  useEffect(() => {
    if (post) {
      const { styles, contentWithoutStyles } = applyStylesToPost(updateImageSrc(post.post, post.images));
      applyShadowDOM(styles, contentWithoutStyles);
    }
  }, [post, updateImageSrc]);

  const handleLike = async () => {
    const newColor = likeColor === 'blue' ? 'grey' : 'blue';
    const increment = newColor === 'blue' ? 1 : -1;

    setLikeColor(newColor);
    setLikeCount((prevCount) => prevCount + increment);

    try {
      await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/${collection}/like/${id}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ like: newColor === 'blue' }),
      });
    } catch (err) {
    
      setLikeColor(likeColor); 
      setLikeCount((prevCount) => prevCount - increment);
    }
  };
  const handleShare = (platform) => {
    const url = window.location.href;
    const postTitle = post ? post.title : 'Check this post!';
    const thumbnail = post && post.image ? convertBinaryToBase64(post.image) : 'default-image-url';
  
    let shareUrl = '';
  
    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(postTitle)}&picture=${encodeURIComponent(thumbnail)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(postTitle)}`;
        break;
      case 'whatsapp':
        shareUrl = `https://wa.me/?text=${encodeURIComponent(postTitle)}%20${encodeURIComponent(url)}`;
        break;
      default:
        return;
    }
  
    window.open(shareUrl, '_blank');
  };
  
  /*const main = {
    entertainments: 'Entertainment',
    movies: 'Movies',
    sports: 'Sports',
    indianhistory:'Indian History',
    untoldhistory:'Untold History',
    mysteries:'Mysteries',
    india:'India',
    world:'World',
    tech:'Tech',
    lifestyle:'Life Style',
    health:'Health & Wealth',
  };*/

  return (
    <>
      <head>
        <meta name="description" content={post ? post.description : "Stay updated with the latest posts on various topics."} />
        <meta name="keywords" content='' />
        <meta property="og:title" content={post ? post.title : 'Latest Post'} />
        <meta property="og:description" content={post ? post.description : 'Stay updated with the latest posts on various topics.'} />
        <meta property="og:image" content={post && post.image ? convertBinaryToBase64(post.image) : 'default-image-url'} />
        <meta property="og:url" content={window.location.href} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={post ? post.title : 'Latest Post'} />
        <meta name="twitter:description" content={post ? post.description : 'Stay updated with the latest posts on various topics.'} />
        <meta name="twitter:image" content={post && post.image ? convertBinaryToBase64(post.image) : 'default-image-url'} />
      </head>

      <section id='news-section2'>
        <div id='typinadd'>
          <Typingadd/>
          <Convertersadd/>
          <Posts collect={collection}/>
        </div>
        <section id="news-section">
          <div id="news-cont">
            {post ? (
              <article>
                
                <header>
                  <p>Created At: {new Date(post.createdAt).toLocaleString()}</p>
                </header>
                <div id="newspan">
                  <span title='Views'>{Math.floor(post.views / 2)}<ion-icon name="eye-outline"></ion-icon></span>
                  <span title='Likes'>
                    {likeCount}
                    <button onClick={handleLike} style={{ color: likeColor }}>
                      <ion-icon name="heart-outline"></ion-icon>
                    </button>
                  </span>  <div className="share-buttons">
        <button title='Facebook' onClick={() => handleShare('facebook')}>
          <ion-icon name="logo-facebook"></ion-icon>
        </button>
        <button title='Twitter' onClick={() => handleShare('twitter')}>
          <ion-icon name="logo-twitter"></ion-icon>
        </button>
        <button title='Whatsapp' onClick={() => handleShare('whatsapp')}>
          <ion-icon name="logo-whatsapp"></ion-icon>
        </button>
      </div>
                </div>
                <section id="mainnews">
                  <div ref={containerRef} />
                </section>
                <Trending collect={collection}/>
              </article>
            ) : (
              <p><img src={load}alt='err'id="loading"/></p>
            )}
          </div>
        </section>  <div id='recent'>
                  <Recent collect={collection}/>
                  </div>
                  
      </section>
  
    </>
  );
}
